<template>
  <div>
    <el-tabs value="tab_pannel" type="border-card" v-model="activeName">
      <el-tab-pane label="出单记录" name="tab_1">
        <el-form ref="form" :model="formQuery" inline size="mini">
          <el-form-item label="保单号：">
            <el-input v-model="formQuery.policyNo" :style="{ width: '200px' }"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="form-inline">
              <el-select v-model="formQuery.optIdType">
                <el-option
                    v-for="item in optId"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
              </el-select>
              <el-input v-model="formQuery.optIdValue"></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="form-inline">
              <el-select v-model="formQuery.optTbrAndBbrType" :style="{ width: '200px' }">
                <el-option
                    v-for="item in optTbrAndBbr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
              </el-select>
              <el-input v-model="formQuery.optTbrAndBbrValue"></el-input>
            </div>
          </el-form-item>
          <el-form-item v-if="!yewuyuanId" label="业务员ID：">
            <el-input v-model="formQuery.ywyId"></el-input>
          </el-form-item>
          <el-form-item label="投保人电话：">
            <el-input v-model="formQuery.socialId"></el-input>
          </el-form-item>
          <el-form-item label="销售主体：">
            <el-select v-model="formQuery.saleEntity">
              <el-option
                  v-for="item in OptSaleEntity"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>

          </el-form-item>

          <el-form-item label="销售渠道：">
            <el-select v-model="formQuery.saleChannel" placeholder="please select your zone">
              <el-option
                  v-for="item in optSaleChannel"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单状态：">
            <el-select v-model="formQuery.state" placeholder="please select your zone">
              <el-option
                  v-for="item in optOrderState"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
                v-model="formQuery.daterange"
                :picker-options="pickerOptions"
                type="datetimerange"
                range-separator="-"
                start-placeholder="Start date"
                end-placeholder="End date">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery">查询</el-button>
            <el-button v-if="user.role == Role.Server || user.role == Role.QiYe" type="primary"
                       @click="exportExcel('')">
              导出订单详情及统计数据Excel
            </el-button>
            <el-button type="primary" @click="handleOpenApplyInvoice(null)">批量开票</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="List" size="mini">
          <el-table-column v-if="user.role == Role.Server" type="expand" fixed="left">
            <template v-slot:="props">
              <vue-json-editor v-model="props.row" :showBtns="true"></vue-json-editor>
            </template>
          </el-table-column>
          <el-table-column label="订单ID" width="230">
            <template v-slot:="scope">
              <span>
                {{ scope.row._id }}
                <el-popover
                    placement="top-start"
                    width="400"
                    trigger="hover">
                <!-- 这里自定义内容 -->
                <div class="popover-content">
                  <template v-if="scope.row.extra">
                    <el-divider content-position="left">保险详细信息</el-divider>
                    <p v-if="scope.row.extra.cd" class="details-text" v-html="getOrderDetail(scope.row)"></p>
                  </template>
                </div>
                  <!-- Reference slot for the popover trigger -->
                <el-button size="mini" slot="reference" type="text" icon="el-icon-info"></el-button>
              </el-popover>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="业务员名字" prop="ywyName" width="90"/>
          <el-table-column label="支付方式" width="80">
            <template v-slot:="scope">
              <div>
                {{ getPayTypeDesc(scope.row.payType) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="销售渠道" width="80">
            <template v-slot:="scope">
              <div>
                {{ getSaleChannelDesc(scope.row.saleChannel) }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="销售主体" prop="saleEntity" width="80" :formatter="getSaleEntity"/>
          <el-table-column label="订单状态" prop="state" width="150">
            <template v-slot:="scope">
              <el-tag
                  :type="getPaymentStateTagInfo(scope.row.state).tag"
                  disable-transitions
              >
                {{ getPaymentStateTagInfo(scope.row.state).label }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="保单号" prop="extra" width="200">
            <template v-slot="scope">
              <div>{{ scope.row.extra.cd ? scope.row.extra.cd.policy_no : "" }}</div>
            </template>
          </el-table-column>

          <el-table-column label="产品名字" prop="extra.product.name" width="200"/>
          <el-table-column label="价格" prop="extra.product.extra.premium" width="50"/>
          <el-table-column label="总单号" prop="orderPackId" width="200"/>
          <el-table-column label="被保人名字" prop="bbrName" width="80"/>
          <el-table-column label="投保人名字" prop="tbrName" width="80"/>
          <el-table-column label="企业ID" prop="qiyeId" width="100"/>
          <el-table-column prop="createdAt" label="创建时间" width="230">
            <template v-slot="scope">
              <div>
                {{ moment(scope.row.createdAt).tz(defaultTimeZone).toISOString(true) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="user.role == Role.Server || user.role == Role.QiYe  || user.role == Role.KeFu"
                           label="操作"
                           width="400">

            <template v-slot="scope">
              <div v-if="[PaymentState.Finish, PaymentState.Expired].includes(scope.row.state)">

                <el-button v-if="!scope.row.extra.kp"
                           style="margin-left: 10px;"
                           size="mini"
                           @click="handleOpenApplyInvoice(scope.row)">开发票
                </el-button>
                <el-button v-else
                           style="margin-left: 10px;"
                           size="mini"
                           @click="openInvoiceFormatDialog(scope.row)">下载电子发票
                </el-button>

                <el-button style="margin-left: 10px;"
                           size="mini"
                           @click="downloadPolicy(scope.$index, scope.row)">下载电子保单
                </el-button>

                <el-button v-if="canDownloadConfirm(scope.row)"
                           style="margin-left: 10px;"
                           size="mini"
                           @click="downloadConfirmDoc(scope.row)">下载投保确认书
                </el-button>

              </div>

              <div
                  v-if="user.role == Role.Server || (user.role == Role.QiYe && (moment().add(-7, 'days') < moment(scope.row.updatedAt)))">
                <el-button
                    v-if="[PaymentState.Finish, PaymentState.Paid, PaymentState.SurrenderedAndWaitForRefund].includes(scope.row.state)"
                    style="margin-left: 10px;"
                    size="mini"
                    @click="refund(scope.$index, scope.row)">退单
                </el-button>
              </div>

              <div v-if="user.role == Role.Server">
                <el-button v-if="[PaymentState.Paid, PaymentState.ToBePaid].includes(scope.row.state)"
                           style="margin-left: 10px;"
                           size="mini"
                           @click="toolsChudan(scope.$index, scope.row)">出单
                </el-button>

                <el-button
                    v-if="scope.row.state === PaymentState.RefundedAndWaitForSurrender"
                    style="margin-left: 10px;"
                    size="mini"
                    @click="refund(scope.$index, scope.row)">退款
                </el-button>

                <el-button
                    v-if="![PaymentState.Refund, PaymentState.Expired, PaymentState.Created].includes(scope.row.state)"
                    style="margin-left: 10px;"
                    size="mini"
                    @click="handleOpenUpdateOrder(scope.row)">修改订单状态
                </el-button>

              </div>

              <el-button
                  v-if="!!scope.row.extra.kp"
                  style="margin-left: 10px;"
                  size="mini"
                  @click="invoiceRedemption(scope.row)">发票红冲
              </el-button>
            </template>

          </el-table-column>

        </el-table>
        <Pagination ref="pagination" @change="onPageChange"/>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="申请发票" :visible.sync="formApplyInvoiceVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="formApplyInvoice" size="mini">
        <el-form-item v-if="formApplyInvoice.orderList.length">
          <el-table :data="formApplyInvoice.orderList" size="mini">
            <el-table-column label="订单ID" prop="_id" width="180"/>
            <el-table-column label="保单号" prop="extra" width="200">
              <template v-slot="scope">
                <div>{{ scope.row.extra.cd ? scope.row.extra.cd.policy_no : "" }}</div>
              </template>
            </el-table-column>
            <el-table-column label="产品名字" prop="extra.product.name" width="200"/>
            <el-table-column label="价格" prop="extra.product.extra.premium" width="200"/>
            <el-table-column label="被保人名字" prop="bbrName" width="200"/>
            <el-table-column label="投保人名字" prop="tbrName" width="200"/>
          </el-table>
          <template>
            <el-radio
                v-model="formApplyInvoice.applyeeType"
                label="P"
                :disabled="formApplyInvoice.orgTaxPayerNo !== ''"
            >
              个人发票
            </el-radio>
            <el-radio v-model="formApplyInvoice.applyeeType" label="B">企业发票</el-radio>
          </template>
        </el-form-item>
        <el-form-item v-else label="输入订单号用小写‘,’分割">
          <el-input v-model="formApplyInvoice.inputOrders"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="formApplyInvoice.applyeeType==='B'" label="发票抬头：">
          <el-input v-model="formApplyInvoice.name"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="formApplyInvoice.applyeeType==='B'" label="纳税人识别号：">
          <el-input v-model="formApplyInvoice.taxPayerNo"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="formApplyInvoice.applyeeType==='B'" label="纳税人地址：">
          <el-input v-model="formApplyInvoice.taxAddress"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="formApplyInvoice.applyeeType==='B'" label="纳税人开户行：">
          <el-input v-model="formApplyInvoice.taxBank"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="formApplyInvoice.applyeeType==='B'" label="纳税人卡号：">
          <el-input v-model="formApplyInvoice.taxBankAccount"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item v-if="formApplyInvoice.applyeeType==='B'" label="电话：">
          <el-input v-model="formApplyInvoice.phone"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="邮箱：">
          <el-input v-model="formApplyInvoice.email"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="备注：">
          <el-input v-model="formApplyInvoice.remarks"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formApplyInvoiceVisible = false">取消</el-button>
        <el-button type="primary" @click.native.prevent="handleApplyInvoice">申请发票</el-button>
      </div>
    </el-dialog>
    <el-dialog title="退保确认" :visible.sync="formRefundVisible">
      <el-form label-width="120px">
        <el-form-item label="保单号">
          <span>{{ formRefund.policyNo }}</span>
        </el-form-item>
        <el-form-item label="产品名称">
          <span>{{ formRefund.productName }}</span>
        </el-form-item>
        <el-form-item label="价格">
          <span>{{ formRefund.productPrice }}</span>
        </el-form-item>
        <el-form-item label="被保人">
          <span>{{ formRefund.insuredName }}</span>
        </el-form-item>
        <el-form-item label="退保需求发起方">
          <el-radio-group v-model="formRefund.refundInitiator">
            <el-radio label="保司"></el-radio>
            <el-radio label="支付平台"></el-radio>
            <el-radio label="机场销售"></el-radio>
            <el-radio label="旅客"></el-radio>
            <el-radio label="其它"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注说明">
          <el-input type="textarea" placeholder="请输入" v-model="formRefund.remark"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="formRefundVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmRefund">确定</el-button>
      </div>

    </el-dialog>
    <el-dialog title="修改订单状态" :visible.sync="formUpdateOrderVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="formUpdateOrder" size="mini">
        <el-form-item>
          <el-radio-group v-model="formUpdateOrder.updateType">
            <el-radio
                v-for="(item,index) in optUpdateOrder"
                :key="index"
                :label="item.label"
            ></el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formUpdateOrderVisible = false">取消</el-button>
        <el-button type="primary" @click="handleUpdateOrder">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择发票格式" :visible.sync="invoiceFormatDialogVisible" width="400px">
      <el-form>
        <el-form-item label="下载格式：">
          <el-radio-group v-model="selectedInvoiceFormat">
            <el-radio label="pdf">PDF</el-radio>
            <el-radio label="ofd">OFD</el-radio>
            <el-radio label="xml">XML</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="invoiceFormatDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmDownloadInvoice">确定下载</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment-timezone"
import VueJsonEditor from '@/components/VueJsonEditor'
import Pagination from '@/components/Pagination'
import {
  getSaleEntity,
  getPaymentStateTagInfo,
  pickerOptions,
  OptSaleEntity, OptsSaleChannel, OptsPaymentState, parseDownloadResponse
} from '@/utils'
import {
  ProductType, SaleChannel, Role, PaymentState, getPayTypeDesc, getSaleChannelDesc,
  defaultTimeZone, CertType,
} from "@/utils/constants";

export default {
  data() {
    const getQiyeName = () => {
      let user = this.$store.state.user;
      return user.qiyeName || "";
    };

    const getQiyeId = () => {
      let user = this.$store.state.user;
      return user.qiyeId || "";
    };
    const getYewuyuanId = () => {
      let user = this.$store.state.user;
      return user.role === Role.YeWuYuan ? user.userId : "";
    };
    return {
      // 角色账号相关
      user: this.$store.state.user,
      qiyeName: getQiyeName(),
      qiyeId: getQiyeId(),
      yewuyuanId: getYewuyuanId(),
      activeName: 'tab_1',
      // 销售渠道
      optSaleChannel: OptsSaleChannel,
      // 订单状态
      optOrderState: OptsPaymentState,
      // 投保人，被保人选项
      optTbrAndBbr: [{value: 'tbr', label: '投保人身份ID'}, {value: 'tbrName', label: '投保人名字'},
        {value: 'bbr', label: '被保人身份ID'}, {value: 'bbrName', label: '被保人名字'}],
      // 单号
      optId: [{value: 'orderPackId', label: '总订单ID'}, {value: 'orderId', label: '订单ID'},],
      // 销售主体
      OptSaleEntity,

      List: [],
      formQuery: {
        policyNo: "",
        optIdType: "orderId",
        optIdValue: "",
        optTbrAndBbrType: "tbr",
        optTbrAndBbrValue: "",
        socialId: '',
        saleEntity: '',
        qiyeId: this.qiyeId,
        ywyId: this.yewuyuanId,
        daterange: [moment("0", "hh").toISOString(), moment("24", "hh").toISOString()],
        state: PaymentState.None,
        saleChannel: SaleChannel.None,
        productType: ProductType.LY,
        orderType: '',
      },

      moment,
      getPayTypeDesc,
      getSaleChannelDesc,
      Role,
      PaymentState,
      getPaymentStateTagInfo,
      defaultTimeZone,
      getSaleEntity,

      // 开企业发票
      formApplyInvoiceVisible: false,
      formApplyInvoice: {
        inputOrders: "",
        phone: "",
        email: "",
        name: "",
        remarks: "",
        taxPayerNo: "",
        orgTaxPayerNo: "",
        orderList: [],
        taxAddress: "",
        taxBank: "",
        taxBankAccount: "",
        applyeeType: "B"
      },

      // 退款
      formRefundVisible: false,
      formRefund: {
        orderId: "",
        policyNo: '',
        productName: '',
        productPrice: 0,
        insuredName: '',
        refundInitiator: '保司',
        remark: ''
      },

      // 修改订单，比如状态等
      optUpdateOrder: [{value: 'red', label: '设置订单为已红冲'}, {
        value: 'refund',
        label: '将订单标记为已退款退保状态'
      },
        {value: 'surrenderedAndWaitForRefund', label: '将订单修改为已退保未退款状态'}],
      formUpdateOrderVisible: false,
      formUpdateOrder: {
        updateType: '',
        orderId: '',
        info: {}
      },

      pickerOptions,

      // 下载发票格式选择
      invoiceFormatDialogVisible: false,
      selectedInvoiceFormat: 'pdf',
      currentInvoiceRow: null,
    }
  },
  methods: {
    getOrderDetail(order) {
      const {cd, tb, baosi} = order.extra;
      return `旅意险建设中`;
    },

    // 标记订单状态
    handleOpenUpdateOrder(order) {
      this.formUpdateOrder.orderId = order._id;
      this.formUpdateOrderVisible = true;
    },
    handleUpdateOrder() {
      const selects = this.optUpdateOrder.filter(item => {
        return item.label === this.formUpdateOrder.updateType
      });
      const updateType = selects.length > 0 ? selects[selects.length - 1].value : '';
      const params = {
        orderId: this.formUpdateOrder.orderId,
        updateType,
        info: this.formUpdateOrder.info,
      }
      this.$axios.post('/payment/order/update', params).then(res => {
        this.$message.info('申请成功');
      }).catch(res => {
        this.logining = false;
      })
    },

    // 开发票
    handleApplyInvoice: function () {
      const orderList = this.formApplyInvoice.orderList;
      const orderIdList = [];
      for (let i = 0; i < orderList.length; i++) {
        orderIdList.push(orderList[i]._id);
      }
      const invoice =  _.merge({}, this.formApplyInvoice);
      const params = {
        orderIdList: orderList.length ? orderIdList : this.formApplyInvoice.inputOrders.split(',').map(id => id.trim()),
        invoice
      }
      const url = orderList.length ? '/payment/order/list/apply/invoice' : '/payment/order/list/apply/invoice1';
      console.log(url, params);
      this.$axios.post(url, params).then(res => {
        // console.log(JSON.stringify(res));
        let wrongList = res.wrongList;
        if (wrongList.length > 0) {
          let wrongOrder = wrongList[0];
          this.$message.error(`申请失败：${wrongOrder.msg}`);
          return;
        }
        this.$message.info('申请成功');
      }).catch(res => {
        this.logining = false;
      })
    },

    handleOpenApplyInvoice: function (order) {
      this.formApplyInvoiceVisible = true;

      this.formApplyInvoice = _.merge(this.formApplyInvoice, {
        orderList : !!order ? [order] : [],
        orgTaxPayerNo: '',
        taxPayerNo: '',
        name: '',
        address: '',
      });

      this.formApplyInvoice.orgTaxPayerNo = '';
      if (!!order) {
        this.formApplyInvoice.inputOrders = "";
        // 单开票，如果投保人是公司，把公司信息带到开票
        const applicant = order.extra.baosi.applicant;
        if(applicant.certi_type === CertType.TYSHXYDM) {
          this.formApplyInvoice = _.merge(this.formApplyInvoice, {
            orgTaxPayerNo: applicant.certi_no,
            taxPayerNo: applicant.certi_no,
            name: applicant.name,
            address: applicant.address,
          });
        }

      } else {
        this.formApplyInvoice.applyeeType = 'B';
      }
    },

    // 红冲
    invoiceRedemption: function (row) {
      this.$confirm("确认红冲发票？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "red"
      }).then(() => {
        let params = {
          orderId: row._id,
        }
        this.$axios.post('/payment/order/apply/redemption', params).then(res => {
          this.$message.info('红冲成功');
        }).catch(res => {
          this.logining = false;
        })
      }).catch(() => {
      })
    },

    download: function (order, downloadType, format = 'pdf', docType) {
      const orderId = order._id;
      const params = new URLSearchParams();
      params.append('orderId', orderId);
      params.append('type', downloadType);
      if (!!format) params.append('ext', format);
      if (!!docType) params.append('docType', docType);
      this.$axios.get(`/proxy/download`, {
        params,
        responseType: 'blob',
      }).then(res => {
        parseDownloadResponse(res, `${order.tbr}.${format}`);
        this.$message.success('导出成功');
      }).catch(res => {
        this.$message.error(`导出失败：${res}`);
        this.logining = false;
      })
    },

    // 下载电子发票
    downloadInvoice: function (index, row, format = 'pdf') {
      this.download(row, 'KP', format)
    },

    openInvoiceFormatDialog(row) {
      this.currentInvoiceRow = row;
      this.invoiceFormatDialogVisible = true;
    },

    confirmDownloadInvoice() {
      this.downloadInvoice(0, this.currentInvoiceRow, this.selectedInvoiceFormat);
      this.invoiceFormatDialogVisible = false;
    },

    // 下载电子保单
    downloadPolicy: function (index, row) {
      this.download(row, 'BD');
    },

    canDownloadConfirm(order) {
      return _.get(order, 'extra.product.downloadConfirm') === 1;
    },

    // 下载投保确认书
    downloadConfirmDoc: function (row) {
      this.download(row, 'BD', 'pdf', 'confirm');
    },

    // 对已付费的出单
    toolsChudan: function (index, row) {
      this.$confirm("确认出单？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "red"
      }).then(() => {
        let params = {
          orderId: row._id,
          payType: row.payType,
        }
        this.$axios.post('/payment/order/tools/chudan', params).then(res => {
          this.$message.info('出单成功');
        }).catch(res => {
          this.logining = false;
        })
      }).catch(() => {
      })
    },

    confirmRefund() {
      const params = {
        orderIdList: [this.formRefund.orderId],
        extra: {
          refundInitiator: this.formRefund.refundInitiator,
          remark: this.formRefund.remark,
        }
      };
      this.$axios.post('/payment/order/list/refund', params).then(res => {
        console.log(JSON.stringify(res));
        const wrongList = res.wrongList;
        if (wrongList.length > 0) {
          const wrongOrder = wrongList[0];
          this.$message.error(`退单失败：${wrongOrder.msg}`);
          return;
        }
        this.$message.info('退单成功');
      }).catch(res => {
        this.logining = false;
      })
    },

    refund: function (index, order) {
      this.formRefund.orderId = order._id;
      this.formRefund.policyNo = order.policyNo;
      this.formRefund.productName = order.extra.product.name;
      this.formRefund.productPrice = order.extra.product.extra.premium;
      this.formRefund.insuredName = order.bbrName;
      if ([PaymentState.SurrenderedAndWaitForRefund, PaymentState.Paid].includes(order.state)) {
        this.$confirm("确认退单？", "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "red"
        }).then(() => {
          this.confirmRefund();
        })
        return;
      }
      this.formRefundVisible = true;
    },

    onPageChange: function (pageSize, currentPage) {
      this.queryOrder(pageSize, (currentPage - 1) * pageSize, this.formQuery).then(res => {
        this.List = res.orderList;
        this.$refs.pagination.setTotal(res.count);
      }).catch(res => {
      })
    },

    handleQuery: function (row, val) {
      const pageSize = this.$refs.pagination.getSize();
      this.queryOrder(pageSize, 0, this.formQuery).then(res => {
        this.List = res.orderList;
        this.$refs.pagination.reset(res.count);
      }).catch(res => {
      })
    },

    queryOrder: function (limit, offset, form) {
      let query = form;
      let params = {
        policyNo: query.policyNo,
        socialId: query.socialId,
        saleEntity: query.saleEntity,
        qiyeId: this.qiyeId || query.qiyeId,
        ywyId: this.yewuyuanId || query.ywyId,
        daterange: query.daterange,
        state: query.state,
        saleChannel: query.saleChannel,
        productType: query.productType,
        // 以下是传过来的
        orderType: query.orderType,
        limit,
        offset
      };
      params[query.optIdType] = query.optIdValue || query[query.optIdType];
      params[query.optTbrAndBbrType] = query.optTbrAndBbrValue || query[query.optTbrAndBbrType];
      return this.$axios.post('/payment/order/list', params).then(res => {
        this.$message.info('查询出单成功');
        return res;
      }).catch(res => {
        this.logining = false;
      })
    },

    exportExcel: function (orderType) {
      let query = orderType === 'refund' ? this.refundFormQuery : this.formQuery;
      let params = {
        socialId: query.socialId,
        saleEntity: query.saleEntity,
        qiyeId: this.qiyeId || query.qiyeId,
        ywyId: this.yewuyuanId || query.ywyId,
        daterange: query.daterange,
        state: query.state,
        saleChannel: query.saleChannel,
        productType: query.productType,

        orderType,
      };
      params[query.optIdType] = query.optIdValue || query[query.optIdType];
      params[query.optTbrAndBbrType] = query.optTbrAndBbrValue || query[query.optTbrAndBbrType];

      if (!query.daterange || query.daterange.length <= 0) {
        this.$message.warning('导出统计数据，需要输入时间');
        return
      }
      const fileName = `统计报表(${moment(query.daterange[0]).tz(defaultTimeZone).toISOString(true)}到${moment(query.daterange[1])
          .tz(defaultTimeZone).toISOString(true)}).zip`;
      this.$axios.post('/statistic/order', params, {
        responseType: 'blob',
        headers: {
          'Content-Type': "application/json",
        },
      }).then(res => {
        parseDownloadResponse(res, fileName);
        this.$message.info('导出成功');
      }).catch(res => {
        this.$message.error(`导出失败：${res}`);
        this.logining = false;
      })
    },

  },

  watch: {},

  created() {
  },

  components: {VueJsonEditor, Pagination},
}
</script>

<style scoped>
.form-inline {
  display: flex;
  align-items: center;
}

.form-inline .el-select,
.form-inline .el-input {
  margin-right: 10px; /* 可根据需要调整间距 */
}
</style>
